/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, signal, Output, EventEmitter, input, effect } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { DesyAngularModule } from 'desy-angular';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { getError } from '@/app/utils/form-errors';
import { AiSystemDeployment, Step4Deployment } from '@/app/interfaces/aiSystemDeployment';
import { forceAtLeastOneFieldFilled, setupConditionalRequiredValidation } from '../helpers/validation.helper';
import { binaryOptions } from '../helpers/binary-options.interface';

@Component({
  selector: 'app-deploy-system-of-ia-step-4',
  templateUrl: './deploy-system-of-ia-step-4.component.html',
  styleUrls: ['./deploy-system-of-ia-step-4.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AutoCompleteModule,
    ButtonsComponent,
    DesyAngularModule,
    DatePickerModule,
    SelectButtonModule,
    MultiSelectModule,
  ],
  providers: [ConfirmationService],
})
export class DeploySystemOfIaStep4Component {
  @Output() stepCompleted = new EventEmitter<Step4Deployment>();
  @Output() goToPreviousStep = new EventEmitter<Step4Deployment | null>();

  existingData = input<Partial<AiSystemDeployment>>();

  form: FormGroup;
  getError = getError;

  binaryOptions = binaryOptions;

  formSubmitted = signal(false);
  iso42001Required = signal(false);
  iso42001ExtraFilled = signal(false);
  dataSovereigntyRequired = signal(false);
  equityAndAccessRequired = signal(false);

  constructor(
    private fb: FormBuilder,
    private router: Router
  ) {
    this.form = this.fb.group({
      iso42001: [null, Validators.required],
      iso42001Csv: null,
      iso42001Description: [null, Validators.maxLength(500)],
      dataSovereignty: [null, Validators.required],
      dataSovereigntyDescription: [null, Validators.maxLength(500)],
      equityAndAccess: [null, Validators.required],
      equityAndAccessDescription: [null, Validators.maxLength(500)],
    });

    setupConditionalRequiredValidation(this.form, this.iso42001Required, null, ['iso42001']);
    forceAtLeastOneFieldFilled(this.form, this.iso42001Required, this.iso42001ExtraFilled, [
      'iso42001Csv',
      'iso42001Description',
    ]);

    setupConditionalRequiredValidation(
      this.form,
      this.dataSovereigntyRequired,
      ['dataSovereigntyDescription'],
      ['dataSovereignty']
    );
    setupConditionalRequiredValidation(
      this.form,
      this.equityAndAccessRequired,
      ['equityAndAccessDescription'],
      ['equityAndAccess']
    );

    effect(() => {
      const data = this.existingData();
      if (data) {
        this.form.patchValue(data);
      }
    });
  }

  async onSave() {
    const formData = this.form.value;
    this.stepCompleted.emit(formData);
  }

  backPage(): void {
    const formData = this.form.value;
    this.goToPreviousStep.emit(formData);
  }

  cancel(): void {
    this.router.navigate([`/catalogo-ia/sistemas-de-ia/listado-sistemas`]);
  }

  confirm() {
    this.formSubmitted.set(true);
    this.onSave();
  }
}
